.BookingDetailsModal {
  .p-dialog-content {
    label {
      font-weight: bold;
      display: block;
    }
  }
}
